const binding = { modules: {}, dataActions: {} };

    (binding.modules['dobbies-free-trial-cancellation'] = {
        c: () => require('partner/modules/dobbies-free-trial-cancellation/dobbies-free-trial-cancellation.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'dobbies-free-trial-cancellation',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/dobbies-free-trial-cancellation'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|dobbies-free-trial-cancellation|dobbies-free-trial-cancellation'] = {
                c: () => require('partner/modules/dobbies-free-trial-cancellation/dobbies-free-trial-cancellation.view.tsx'),
                cn: '__local__-__local__-dobbies-free-trial-cancellation'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };